import InsuranceAutocomplete from './InsuranceAutocomplete'

export default InsuranceAutocomplete
